// import { CallNumber } from "@ionic-native/call-number";
import {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  PhoneNumber,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  PhoneNumberFormat,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  PhoneNumberUtil,
} from "google-libphonenumber";
import dateAndTime from "date-and-time";
import { isArray } from "lodash";

//
// Helper to validate a phone number
//
export const validPhoneNumber = (phoneNumber: string) => {
  let validPhone = false;
  try {
    // Get an instance of `PhoneNumberUtil`.
    const phoneUtil =
      require("google-libphonenumber").PhoneNumberUtil.getInstance();
    validPhone = phoneUtil.isValidNumberForRegion(
      phoneUtil.parse(phoneNumber, "AU"),
      "AU"
    );
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e: any) {
    /* squash */
    // console.log("Invalid phone number: ", e?.message);
  }
  return validPhone;
};

export const formatPhoneNumber = (phoneNumber: string) => {
  let formattedPhone = "";
  try {
    // Get an instance of `PhoneNumberUtil`.
    const PNF = require("google-libphonenumber").PhoneNumberFormat;
    const phoneUtil =
      require("google-libphonenumber").PhoneNumberUtil.getInstance();
    // Parse number with country code and keep raw input.
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, "AU");
    formattedPhone = phoneUtil.format(number, PNF.INTERNATIONAL);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e: any) {
    /* squash */
    // console.log("Invalid phone number: ", e?.message);
  }
  return formattedPhone;
};

//
// Call a number on device
//
export const callNumber = (phoneNumber: string) => {
  console.log("Calling number: ", phoneNumber);
  let validPhone = validPhoneNumber(phoneNumber);

  if (validPhone) {
    const telLink = "tel:" + phoneNumber;
    console.log("telLink: ", telLink);
    launchExternal(telLink);
    // CallNumber.callNumber(phoneNumber, true)
    //   .then((res: any) => console.log("Launched dialer!", res))
    //   .catch((err: any) => console.log("Error launching dialer", err));
  } else {
    console.error("Invalid phone number format for: ", phoneNumber);
  }
};

export const launchExternal = async (url: string) => {
  let win;
  try {
    win = window.open(url);
  } catch (err) {
    console.log("Error launching external url:", err);
  }
  return win;
};

/**
 * Decode a JSON Web Token (jwt)
 */
export const decodeJwt = (jwt: string) => {
  try {
    // const decoded = Buffer.from(jwt.split(".")[1], "base64");
    return JSON.parse(atob(jwt.split(".")[1]));
    // return JSON.parse(decoded.toString());
  } catch (e: any) {
    console.log(`${decodeJwt} Error: decoding JWT.`, e?.message);
  }
};

export const formatDate = (value: string | string[]) => {
  const datestr: string =
    isArray(value) && value.length > 0 ? value[0].toString() : value.toString();
  return dateAndTime.format(new Date(Date.parse(datestr)), "YYYY-MM-DD");
};

export const formatDateTime = (value: string | string[], utc=false) => {
  const datestr: string =
    isArray(value) && value.length > 0 ? value[0].toString() : value.toString();
  return dateAndTime.format(new Date(Date.parse(datestr)), "YYYY-MM-DD HH:mm", utc);
};